var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.38 4.86884C21.5849 5.21758 20.7377 5.44873 19.8545 5.56097C20.7631 5.01849 21.4567 4.16602 21.7827 3.13852C20.9355 3.64359 20.0001 4.00034 19.0033 4.19943C18.1989 3.34295 17.0524 2.8125 15.8016 2.8125C13.375 2.8125 11.4214 4.78199 11.4214 7.19642C11.4214 7.54382 11.4508 7.87786 11.523 8.19586C7.87901 8.01816 4.65464 6.2718 2.48858 3.61152C2.11042 4.26757 1.88861 5.01849 1.88861 5.82686C1.88861 7.34473 2.67031 8.69024 3.83552 9.46922C3.13132 9.45586 2.44048 9.25143 1.8552 8.92941C1.8552 8.94277 1.8552 8.96014 1.8552 8.97751C1.8552 11.1073 3.37452 12.8764 5.36686 13.2839C5.01009 13.3815 4.62124 13.4282 4.21769 13.4282C3.93708 13.4282 3.65379 13.4122 3.38788 13.3534C3.95578 15.0891 5.5673 16.3651 7.48349 16.4065C5.99223 17.573 4.09876 18.2758 2.04896 18.2758C1.68951 18.2758 1.34475 18.2598 1 18.2157C2.94157 19.4677 5.24259 20.1825 7.72401 20.1825C15.7896 20.1825 20.1992 13.5017 20.1992 7.71084C20.1992 7.5171 20.1926 7.33004 20.1832 7.14431C21.0531 6.52701 21.784 5.75605 22.38 4.86884Z",
    fill: "#B1BFB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e2bf2d2b9db298104d8593c01d65df09.svg";
export { ForwardRef as ReactComponent };